import { css } from "lit";

export const styles = css`
  .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1;
  }

  .error-message {
    color: var(--sds-color-text-danger-primary);
    font-size: 14px;
    margin-top: 4px;
  }

  .end-event-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background: var(--sds-color-background-danger-subtle);
    border-radius: var(--sds-border-radius-03);
    border: 1px solid var(--sds-color-border-danger-default);
    margin-top: 8px;
  }

  .warning-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--sds-color-text-danger-default);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .warning-banner ph-warning {
    flex-shrink: 0;
  }

  .end-event-section wow-button {
    align-self: flex-start;
    min-width: 140px;
  }

  .background-images-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .background-images-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }

    .end-event-section {
      padding: 16px;
    }

    .end-event-section wow-button {
      width: 100%;
    }

    .background-images-grid {
      grid-template-columns: 1fr;
    }
  }
`;
